import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "types/store";
import { Dialog, DialogContent, DialogFooter, DialogHeader } from "@/aible/Dialog/Dialog";
import { Button } from "aible";
import AlwaysOnIcon from "images/Optimize-Agent-Icon.svg";
import styles from "./style.module.css";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";
import ModelSelector from "components/ChatGPT/ModelSelector";
const AiqModal = ({ open, onOpenChange }) => {
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const [isStartingAgent, setIsStartingAgent] = useState(false);
    const [aiqPrompt, setAiqPrompt] = useState("");
    const promptRef = useRef(null);
    const isDeepResearch = chatType === "AIQ_DEEP_RESEARCH";
    let modalTitle = "AI-Q Deep Research Agent Setup";
    useEffect(() => {
        if (open && promptRef?.current) {
            promptRef.current.focus();
        }
    }, [open]);
    const resetModalDefaults = () => {
        setIsStartingAgent(false);
        setAiqPrompt("");
    };
    const handleCloseModal = () => {
        resetModalDefaults();
        onOpenChange(!open);
    };
    const handleStartDeepResearch = async () => {
        setIsStartingAgent(true);
        try {
            await dispatch(aibleAnywhereReducer.startAiqDeepResearch(aiqPrompt, aiqPrompt));
            handleCloseModal();
            setIsStartingAgent(false);
        }
        catch {
            console.log("Failed to start research: ", aiqPrompt);
            setIsStartingAgent(false);
        }
    };
    return (React.createElement(Dialog, { open: open, onOpenChange: () => handleCloseModal() },
        React.createElement(DialogContent, { size: "lg", showCloseButton: true, onInteractOutside: (e) => e.preventDefault() },
            React.createElement(DialogHeader, null,
                React.createElement("div", { className: styles.agentCHeader },
                    React.createElement("div", { className: styles.wizardHeaderLogoWrapper },
                        React.createElement("img", { className: styles.wizardHeaderLogo, src: AlwaysOnIcon })),
                    modalTitle)),
            React.createElement("div", { className: "mt-[10px]" },
                React.createElement(AiqSetupBody, { promptRef: promptRef, isStartingAgent: isStartingAgent, aiqPrompt: aiqPrompt, setAiqPrompt: setAiqPrompt })),
            React.createElement(DialogFooter, null,
                React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                    React.createElement(Button, { onClick: () => handleCloseModal() }, "Cancel"),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            if (isDeepResearch) {
                                return handleStartDeepResearch();
                            }
                        }, isLoading: isStartingAgent }, "Start Deep Research"))))));
};
const AiqSetupBody = ({ promptRef, isStartingAgent, aiqPrompt, setAiqPrompt }) => {
    const dispatch = useDispatch();
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isDeepResearch = chatType === "AIQ_DEEP_RESEARCH";
    let inputTitle = "What would you like to research?";
    let inputDescription = "Aible will use the deep research agent to answer your question";
    return (React.createElement("div", { className: "text-[14px]" },
        React.createElement("div", { className: "mb-[10px]" },
            React.createElement("div", { className: "font-bold" }, inputTitle),
            React.createElement("div", null, inputDescription)),
        React.createElement("textarea", { className: styles.agentCTextArea, style: { height: "160px" }, value: aiqPrompt, placeholder: "Describe what you would like the agent to do", onChange: (e) => setAiqPrompt(e?.currentTarget?.value), disabled: isStartingAgent, ref: promptRef }),
        React.createElement("div", null,
            React.createElement("div", { className: "flex items-center mt-[10px]" },
                React.createElement("span", { style: { color: "#202939" } }, "AI Model"),
                React.createElement(ModelSelector, { hideIcons: true, isCreatable: true, selectorStyle: {
                        marginLeft: "15px"
                    }, style: { flexShrink: "1", whiteSpace: "normal", padding: "2px" }, isDisabled: isStartingAgent, menuPlacement: "top" })),
            React.createElement(AdvancedSettings, { show: showAdvancedSettings }))));
};
const AdvancedSettings = ({ show }) => {
    return (React.createElement("div", { className: show ? styles.generationSettings + " " + styles.show : styles.generationSettings }));
};
export default AiqModal;
